import { UAParser } from 'ua-parser-js'

export const ua = new UAParser()
